import { render, staticRenderFns } from "./formUnitNew.vue?vue&type=template&id=29b5a80e&scoped=true&"
import script from "./formUnitNew.vue?vue&type=script&lang=js&"
export * from "./formUnitNew.vue?vue&type=script&lang=js&"
import style0 from "./formUnitNew.vue?vue&type=style&index=0&id=29b5a80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5a80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b5a80e')) {
      api.createRecord('29b5a80e', component.options)
    } else {
      api.reload('29b5a80e', component.options)
    }
    module.hot.accept("./formUnitNew.vue?vue&type=template&id=29b5a80e&scoped=true&", function () {
      api.rerender('29b5a80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formUnitNew.vue"
export default component.exports